import type { DisplayLogic } from '../../fetchSurvey/types/survey';
import type { LogicContext } from '../types';
import { evaluateCondition } from './evaluateCondition';

export function evaluateDisplayLogic(
  displayLogic: DisplayLogic | undefined,
  context: LogicContext
): boolean {
  if (!displayLogic) {
    return true;
  }

  return evaluateCondition(displayLogic.condition, context);
}
